import { render, staticRenderFns } from "./Passport.vue?vue&type=template&id=5b372e0e&"
import script from "./Passport.vue?vue&type=script&lang=js&"
export * from "./Passport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports